import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import RegionBranchMultipleSelect from 'component/branch/RegionBranchMultipleSelectNew'
import TextField from 'component/TextField'
import Button from 'component/Button/index'
import moment from 'moment'
import Select from '../Select/Select'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'

const START_YEAR = '2019'
const emptyFormData = {
  branchs: [],
  sections: [],
  year: '',
  depositType: [],
}


class Form extends React.Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    initialValues: PropTypes.object,
    isUserMatriz: PropTypes.bool,
    isSideFilter: PropTypes.bool
  }

    relatoryOptions = [
    {label: "RCP", value: "RCP"},{label: "AER", value: "AER"},{label: "DVF", value: "DVF",}
  ]

  state = {
    cleanedFilter: false,
    years: [],
    prevFormData: {
      branchs: [],
      sections: [],
      year: '',

    },
    formData: {
      branchs: [],
      sections: [],
      year: '',
      depositType: [],
      depositTypeOptions: []
    },
  }

  getDepositOptionsParams = (values) => {
    const {user} = this.props
    return new Api(user.dsToken)
    .get(API_URL.PARAMETER_GET, values, "")
    .then(resp => {
      const depositTypes = resp.data.split(",").map((item) => ({label: item, value: item}))
      this.setState({depositTypeOptions: depositTypes})
    })
  }

  
  
  hasNonEmptyValue() {

    return Object.values(this.state.formData).some(value => {
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      return value !== '';
    });
  }

  

  prevHasNonEmptyValue() {

    return Object.values(this.state.prevFormData).some(value => {
     
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      return value !== '';
    });
  }

 

  componentDidMount() {

    const depositTypeParams = {
      dsKey: 'irc.supply.deposit.type',
      nuParameter: 1
    }

    this.getDepositOptionsParams(depositTypeParams)
    this.checkInitialValues()
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isSideFilter && this.props.isSideFilter && this.prevHasNonEmptyValue()) {
      this.setState({formData: this.state.prevFormData}, () => this.setState({prevFormData: {...emptyFormData}}))
    }
  }

  checkInitialValues() {
    const { initialValues } = this.props
    const { formData } = this.state

    if (initialValues) {
      const fields = ['branchs', 'sections', 'year', 'depositType']

      fields.forEach((field) => {
        if (initialValues[field]) {
          formData[field] = initialValues[field]
        }
      })

      this.setState({ formData })
    }
  }

  handleChange(name, value) {
    const { formData } = this.state

    formData[name] = value

    this.setState({ formData })
  }

  isSubmitDisabled() {
    const { formData } = this.state

    let disabled = false

    const toValidate = ['branchs', 'year', 'depositType' ]

    for (const field of toValidate) {
      if (
        (Array.isArray(formData[field]) && formData[field].length === 0) ||
        !formData[field]
      ) {
        disabled = true
        break
      }
    }

    if (!this.validateYear(formData.year)) {
      disabled = true
    }

    return disabled
  }

  handleSubmit = () => {
    const { onSubmit } = this.props
    const { formData } = this.state
    if(this.state.cleanedFilter) this.setState({cleanedFilter: false})
    onSubmit(formData)
  }

  validateYear = (year) => {
    const years = []
    const from = parseInt(START_YEAR, 10)
    const to = parseInt(moment().format('Y'), 10)

    for (let i = from; i <= to; i++) {
      years.push(i.toString())
    }

    return years.indexOf(year) !== -1
  }

  resetFilters = () => {
    this.setState({prevFormData: this.state.formData}, () => this.setState({formData: {...emptyFormData} }, () => this.setState({cleanedFilter: true})) )
  }

  render() {
    const { translate, user, isUserMatriz, isSideFilter = false } = this.props
    const { formData,depositTypeOptions } = this.state

    const fromYear = START_YEAR
    const toYear = moment().format('Y')

    return (
      <div className='section-accuracy-form'>
        <div>
          <RegionBranchMultipleSelect
            translate={translate}
            user={user}
            label={translate('sectionAccuracy.dsBranch')}
            placeholder={translate('field.selectMultiStores')}
            onChange={(e) => this.handleChange('branchs', e.target.value)}
            value={!isUserMatriz ? [{ value: user.locationCode.padStart(4, '0') }] : formData.branchs}
            required
            disabled={!isUserMatriz}
          />
        </div>
    
        <div>
          <Select
          value={formData.depositType}
          isMulti
          fill
          required
          groupOptions
          selectAll
          name={"depositType"}
          options={depositTypeOptions || []}
          translate={translate}
          label={"Tipo de depósito"}
          placeholder={"Selecione um ou mais depósitos"}
          onChange={(e) => {
            this.setState({formData: {...this.state.formData, depositType: e}})
          }} />
            
        </div>
        <div>
          <TextField
            label={translate('sectionAccuracy.dtYear')}
            placeholder={translate('sectionAccuracy.choose-dtYear')}
            value={formData.year}
            onChange={(e) => this.handleChange('year', e.target.value)}
            maxLength='4'
            mask='9999'
            required
            fill
            validateValue={this.validateYear}
            helpText={translate('sectionAccuracy.help-dtYear')
              .replace('{from}', fromYear)
              .replace('{to}', toYear)}
            errorText={translate('sectionAccuracy.help-dtYear')
              .replace('{from}', fromYear)
              .replace('{to}', toYear)}
          />
        </div>
        {isSideFilter 
        ?  
        <div style={{padding: 0}} className='flex flex-row gap-filters padding-filters'>

              <button
                className={`btn btn-danger-outline full-w`}
                onClick={() => this.resetFilters()}
              >
                {translate('suggestions.cleanFilters')}
              </button>


              <button
                      className={`btn btn-primary full-w`}
                      disabled={this.isSubmitDisabled()}
                      onClick={this.handleSubmit}
                    >
                      {translate('commonReport.filter')}
                </button>

            </div>
        :  
        <div className='margin-top-double'>
          <Button
            className='btn btn-primary w-100'
            text={translate('filter_button_label')}
            onClick={this.handleSubmit}
            disabled={this.isSubmitDisabled()}
          />

          
        </div>
        }
      </div>
    )
  }
}

const mapStateToProps = ({ auth }) => ({
  isUserMatriz: auth.isUserMatriz,
  user: auth.user
})

export default connect(mapStateToProps)(Form)

export { Form }
